import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import _ from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import { Icon } from '../../Icon';
import Shimmer from '../../Shimmer';
import { withTheme, getThemeImages } from '../../Themes';
import VFText from '../../VFText';
import styles from '../VFHeader.Styles';

import { headerLoadingConfig, shimmerPlaceholderConfig } from './SubTitleConfig';

const SubTitle = ({
  subHeaderTitle,
  subHeaderTitlePlaceholders,
  subHeaderTitleNumberOfLines,
  subHeaderSubTitle,
  subHeaderSubTitlePlaceholders,
  renderSubHeaderRightComponent,
  subTitleSubHeaderAndRightComponentContainerStyle,
  subHeaderRightComponentStyle,
  subHeaderBeforeSubTitle,
  subHeaderAfterSubTitle,
  subHeaderTitleStyle,
  subHeaderTitleContainerStyle,
  subHeaderSubTitleStyle,
  subHeaderBeforeSubTitleStyle,
  subHeaderAfterSubTitleStyle,
  renderSubHeaderSubTitle,
  renderSubHeaderTitle,
  subHeaderTitleAccessibilityLabel,
  subHeaderSubTitleAccessibilityLabel,
  subHeaderBeforeSubTitleAccessibilityLabel,
  subHeaderAfterSubTitleAccessibilityLabel,
  subHeaderSubTitleViewStyle,
  theme,
  allowFontScaling,
  renderAftersubHeaderAfterSubTitle,
  isSubHeaderLoading,
  isSubHeaderError,
  onErrorTryAgainPress,
  subHeaderErrorSubTitleStyle,
  subHeaderErrorSecondIcon,
  errorShimmerViewStyle,
  subtitleHeaderErrorTryAgainStyle,
  subHeaderErrorTitleStyle,
}) => {
  const _renderSubHeaderTitle = () => (
    <View
      style={[styles.subHeaderTitleContainerStyle, subHeaderTitleContainerStyle]}
      testID={FoundationTestKeys.subHeaderTitleView}
    >
      <VFText
        i18nKey={subHeaderTitle}
        placeHolders={subHeaderTitlePlaceholders}
        style={[styles.subHeaderTitleStyle(theme), subHeaderTitleStyle]}
        allowFontScaling={allowFontScaling}
        numberOfLines={subHeaderTitleNumberOfLines}
        testKey={subHeaderTitleAccessibilityLabel}
      />
    </View>
  );

  const _renderSubHeaderSubTitle = () =>
    (subHeaderBeforeSubTitle || subHeaderSubTitle || subHeaderAfterSubTitle) && (
      <View
        style={[styles.subHeaderSubTitleViewStyle, subHeaderSubTitleViewStyle]}
        testID={FoundationTestKeys.subHeaderSubtitleView}
      >
        {!!subHeaderBeforeSubTitle && (
          <VFText
            i18nKey={subHeaderBeforeSubTitle}
            style={[styles.subHeaderSubTitleSecondaryText(theme), subHeaderBeforeSubTitleStyle]}
            testID={subHeaderBeforeSubTitleAccessibilityLabel}
            allowFontScaling={allowFontScaling}
            testKey={FoundationTestKeys.subHeaderBeforeSubtitleText}
          />
        )}

        {!!subHeaderSubTitle && !isSubHeaderError && !isSubHeaderLoading && (
          <VFText
            i18nKey={subHeaderSubTitle}
            placeHolders={subHeaderSubTitlePlaceholders}
            style={[styles.subHeaderSubTitleMainText(theme), subHeaderSubTitleStyle]}
            testID={subHeaderSubTitleAccessibilityLabel}
            allowFontScaling={allowFontScaling}
            testKey={FoundationTestKeys.subHeaderSubtitleMainText}
          />
        )}

        {!!subHeaderAfterSubTitle && !isSubHeaderError && !isSubHeaderLoading && (
          <VFText
            i18nKey={subHeaderAfterSubTitle}
            style={[styles.subHeaderSubTitleSecondaryText(theme), subHeaderAfterSubTitleStyle]}
            testID={subHeaderAfterSubTitleAccessibilityLabel}
            allowFontScaling={allowFontScaling}
            testKey={FoundationTestKeys.subHeaderAfterSubtitleText}
          />
        )}

        {_.isFunction(renderAftersubHeaderAfterSubTitle) && renderAftersubHeaderAfterSubTitle()}
      </View>
    );

  const _renderSubHeaderError = () => (
    <TouchableOpacity
      onPress={onErrorTryAgainPress}
      testID={FoundationTestKeys.subHeaderErrorAccessibilityLabel}
      hitSlop={{
        bottom: 15,
        left: 15,
        right: 15,
        top: 15,
      }}
      style={[styles.subtitleHeaderErrorTryAgainStyle, subtitleHeaderErrorTryAgainStyle]}
    >
      <Icon
        name={getThemeImages(theme.name).ic_warning_mid}
        type={'image'}
        size={25.5}
        testID={FoundationTestKeys.subHeaderErrorFirstIcon}
      />
      <VFText
        i18nKey="subHeader_Error_Title"
        style={[
          styles.subHeaderSubTitleSecondaryText(theme),
          styles.subHeaderErrorTitleStyle,
          subHeaderErrorTitleStyle,
        ]}
        testID={FoundationTestKeys.subHeaderErrorTitle}
        allowFontScaling={allowFontScaling}
      />
      <VFText
        i18nKey="subHeader_Error_SubTitle"
        style={[styles.subHeaderSubTitleSecondaryText(theme), subHeaderErrorSubTitleStyle]}
        testID={FoundationTestKeys.subHeaderErrorSubTitle}
        allowFontScaling={allowFontScaling}
      />
      <Icon
        name={subHeaderErrorSecondIcon}
        type={'image'}
        size={25.5}
        testID={FoundationTestKeys.subHeaderErrorSecondIcon}
      />
    </TouchableOpacity>
  );

  return (
    <View
      style={[
        styles.subTitleSubHeaderAndRightComponentContainer,
        subTitleSubHeaderAndRightComponentContainerStyle,
      ]}
      testID={FoundationTestKeys.subHeaderContainer}
    >
      <View testID={FoundationTestKeys.subHeaderContainerView}>
        {renderSubHeaderTitle ? renderSubHeaderTitle() : _renderSubHeaderTitle()}

        {isSubHeaderLoading && (
          <View
            style={[styles.errorShimmerViewStyle, errorShimmerViewStyle]}
            testID={FoundationTestKeys.subHeaderLoadingView}
          >
            <Shimmer
              config={headerLoadingConfig}
              shimmerPlaceholderConfig={shimmerPlaceholderConfig}
            />
          </View>
        )}

        {!isSubHeaderLoading && isSubHeaderError && _renderSubHeaderError()}

        {renderSubHeaderSubTitle ? renderSubHeaderSubTitle() : _renderSubHeaderSubTitle()}
      </View>

      {_.isFunction(renderSubHeaderRightComponent) && (
        <View
          style={[styles.subHeaderRightComponent, subHeaderRightComponentStyle]}
          testID={FoundationTestKeys.subHeaderRightComponentView}
        >
          {renderSubHeaderRightComponent()}
        </View>
      )}
    </View>
  );
};

SubTitle.defaultProps = {
  subHeaderTitleStyle: {},
  subHeaderTitleContainerStyle: {},
  subHeaderBeforeSubTitleStyle: {},
  subHeaderAfterSubTitleStyle: {},
  subHeaderSubTitleStyle: {},
  errorShimmerViewStyle: {},
  subtitleHeaderErrorTryAgainStyle: {},
  subHeaderErrorTitleStyle: {},
  renderSubHeaderRightComponent: null,
  subHeaderTitleNumberOfLines: undefined,
  isSubHeaderError: false,
  isSubHeaderLoading: false,
};

SubTitle.propTypes = {
  subHeaderTitleNumberOfLines: PropTypes.number,
  subHeaderTitle: PropTypes.string,
  subHeaderSubTitlePlaceholders: PropTypes.arrayOf(PropTypes.any),
  subHeaderTitlePlaceholders: PropTypes.arrayOf(PropTypes.any),
  subHeaderSubTitle: PropTypes.string,
  renderSubHeaderRightComponent: PropTypes.func,
  subTitleSubHeaderAndRightComponentContainerStyle: ViewPropTypes.style,
  subHeaderRightComponentStyle: ViewPropTypes.style,
  subHeaderBeforeSubTitle: PropTypes.string,
  subHeaderAfterSubTitle: PropTypes.string,
  renderSubHeaderSubTitle: PropTypes.func,
  renderSubHeaderTitle: PropTypes.func,
  subHeaderTitleStyle: TextPropTypes.style,
  subHeaderTitleContainerStyle: ViewPropTypes.style,
  subHeaderBeforeSubTitleStyle: ViewPropTypes.style,
  subHeaderAfterSubTitleStyle: ViewPropTypes.style,
  subHeaderSubTitleStyle: TextPropTypes.style,
  subHeaderTitleAccessibilityLabel: ViewPropTypes.accessibilityLabel,
  subHeaderSubTitleAccessibilityLabel: ViewPropTypes.accessibilityLabel,
  subHeaderBeforeSubTitleAccessibilityLabel: ViewPropTypes.accessibilityLabel,
  subHeaderAfterSubTitleAccessibilityLabel: ViewPropTypes.accessibilityLabel,
  theme: PropTypes.object,
  allowFontScaling: PropTypes.bool,
  subHeaderSubTitleViewStyle: ViewPropTypes.style,
  renderAftersubHeaderAfterSubTitle: PropTypes.func,
  isSubHeaderLoading: PropTypes.bool,
  isSubHeaderError: PropTypes.bool,
  onErrorTryAgainPress: PropTypes.func,
  subHeaderErrorSubTitleStyle: TextPropTypes.style,
  subHeaderErrorSecondIcon: PropTypes.object,
  errorShimmerViewStyle: ViewPropTypes.style,
  subtitleHeaderErrorTryAgainStyle: TextPropTypes.style,
  subHeaderErrorTitleStyle: TextPropTypes.style,
};
export default withTheme(SubTitle);
